import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import moment from "moment";
import Grid from "@material-ui/core/Grid";
import {
  runReport,
  setReportDateRange,
  setReportLoading,
  setReportData,
} from "../../../Redux/Actions/reportActions";
import SuspendedAgentsReportDist from "../../Cards/Reports/DistributorReports/SuspendedAgentsReportDist/SuspendedAgentsReportDist";
import { BASE_API_URL } from "../../../Utils/constants";

class SuspendedAgentsPageDist extends Component {
  async componentDidMount() {
    try {
      this.props.setReportLoading(true);
      await this.props.runReport(
        `${BASE_API_URL}/distributor/billing/suspended`
      );
      this.props.setReportLoading(false);
    } catch (error) {
      this.props.setReportLoading(false);
    }
  }

  componentWillUnmount() {
    const NOW = moment().format("MM/DD/YYYY");
    this.props.setReportDateRange(NOW, NOW);
    this.props.setReportData([]);
  }

  render() {
    return (
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <SuspendedAgentsReportDist />
        </Grid>
      </Grid>
    );
  }
}

SuspendedAgentsPageDist.propTypes = {
  runReport: PropTypes.func.isRequired,
  setReportDateRange: PropTypes.func.isRequired,
  setReportLoading: PropTypes.func.isRequired,
  setReportData: PropTypes.func.isRequired,
};

export default connect(null, {
  runReport,
  setReportDateRange,
  setReportLoading,
  setReportData,
})(SuspendedAgentsPageDist);
